import Uppy from '@uppy/core'; /*
import Dashboard from "@uppy/dashboard"; */
import {DashboardModal} from '@uppy/react';
import AwsS3, {AwsS3Options} from '@uppy/aws-s3';
import ms from 'ms';
import {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Image} from '@fluentui/react';
import {useGetArticleImageUploadParametersRequest} from '../api/articles';
import {connect} from 'react-redux';

require('@uppy/core/dist/style.css');
require('@uppy/dashboard/dist/style.css');

const getUppyInstance = (
  onComplete: () => void,
  getUploadParameters: AwsS3Options['getUploadParameters'],
) =>
  Uppy<Uppy.StrictTypes>({
    restrictions: {
      maxNumberOfFiles: 1,
      minNumberOfFiles: 1,
      allowedFileTypes: ['image/*'],
      maxFileSize: 1000000,
    },
  })
    .use(AwsS3, {
      limit: 1,
      timeout: ms('1 minute'),
      getUploadParameters,
    })
    .on('upload-success', onComplete);

type ImageUploaderProps = {
  imageSrc?: string;
  onImageChange?: (newSrc: string) => void;
  articleId: string;
  errorMessage?: string;
  token: string;
};

const ImageUploader = (props: ImageUploaderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const getImageUploadParameters = useGetArticleImageUploadParametersRequest(
    props.token,
  );

  const currentImageUrlRef = useRef<string>();

  const uploadParametersGetter = useCallback(
    async (file: Uppy.UppyFile) => {
      const uploadParameters = await getImageUploadParameters(
        props.articleId,
        file.name,
        file.type!,
      );

      currentImageUrlRef.current = uploadParameters.getUrl;

      return {
        method: uploadParameters.method,
        url: uploadParameters.uploadUrl,
        fields: {},
        headers: {
          'Content-Type': file.type!,
        },
      };
    },
    [props.articleId, getImageUploadParameters],
  );

  const uppy = useMemo(
    () =>
      getUppyInstance(() => {
        setIsOpen(false);
        if (currentImageUrlRef.current !== undefined && props.onImageChange)
          props.onImageChange(currentImageUrlRef.current);
      }, uploadParametersGetter),
    [props, uploadParametersGetter],
  );

  useEffect(() => {
    if (!isOpen) {
      document
        .querySelector('body')
        ?.classList.remove('uppy-Dashboard-isFixed');
    }
  }, [isOpen]);

  return (
    <>
      <Image
        style={{cursor: 'pointer', marginLeft: 'auto', marginRight: 'auto'}}
        onClick={() => setIsOpen(true)}
        src={
          props.imageSrc ??
          'https://lunawood.com/wp-content/uploads/2018/02/placeholder-image.png'
        }
      />
      {props.errorMessage && (
        <p className="ms-TextField-errorMessage errorMessage-59">
          <span>{props.errorMessage}</span>
        </p>
      )}
      <DashboardModal
        uppy={uppy}
        open={isOpen}
        onRequestClose={() => setIsOpen(false)}
      />
    </>
  );
};
interface configObject {
  user: {
    token: string;
  };
}

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
  };
};
export default connect(mapStateToProps)(ImageUploader);
